import { render, staticRenderFns } from "./SectionEvusReminder.vue?vue&type=template&id=f309670e&scoped=true"
import script from "./SectionEvusReminder.vue?vue&type=script&lang=js"
export * from "./SectionEvusReminder.vue?vue&type=script&lang=js"
import style0 from "./SectionEvusReminder.vue?vue&type=style&index=0&id=f309670e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f309670e",
  null
  
)

export default component.exports